import m from 'mithril'
import clsx from 'clsx'
import { initMithrilComponent } from '@client-shared/utils/mithril'
import UploadsRowItem from './uploads-row-item'
import IconButton from '@client-shared/components-v2/icon-button'
import IconChevronDown from '@client-shared/icons-v2/chevron-down'
import IconXClose from '@client-shared/icons-v2/x-close'
import UploadsManager, { type UpdateHandlerFunc, type UploadItem } from '../../util/uploads-manager'

import s from './uploads-container.module.scss'

interface Attrs extends m.Attributes {
	onClose?: () => void
	onCancelUpload?: (id: string) => void
}

interface State {
	upload_items: UploadItem[]
	is_dismissible: boolean
	is_collapsed: boolean
	uploadItemsUpdateHandler: UpdateHandlerFunc
}

const UploadsContainer = initMithrilComponent<Attrs, State>()

UploadsContainer.oninit = (vnode) => {
	vnode.state.upload_items = UploadsManager.upload_items
	vnode.state.is_dismissible = !UploadsManager.uploads_in_progress
	vnode.state.is_collapsed = false

	vnode.state.uploadItemsUpdateHandler = async () => {
		vnode.state.upload_items = UploadsManager.upload_items
		vnode.state.is_dismissible = !UploadsManager.uploads_in_progress

		m.redraw()
	}

	UploadsManager.onUpdate(vnode.state.uploadItemsUpdateHandler)
}

UploadsContainer.onremove = (vnode) => {
	UploadsManager.removeUpdateHandler(vnode.state.uploadItemsUpdateHandler)
}

UploadsContainer.view = (vnode) => {
	const { onClose = () => {}, onCancelUpload, class: add_class } = vnode.attrs
	const { upload_items, is_dismissible, is_collapsed } = vnode.state

	const num_uploading = upload_items.reduce(
		(acum, item) => (item.status === 'uploading' || item.status === 'post-processing' ? acum + 1 : acum),
		0,
	)

	return m('div', { class: clsx(s.uploads_container, add_class, is_collapsed && 'collapsed') }, [
		m('div', { class: s.header }, [
			m(
				'span',
				{ class: s.header_title },
				num_uploading > 0 ? `Uploading ${num_uploading} Region File${num_uploading !== 1 ? 's' : ''}` : 'Upload Status',
			),
			m('div', { class: s.header_buttons }, [
				is_dismissible &&
					m(IconButton, {
						icon: IconXClose,
						'aria-label': 'Close uploads container',
						onClick: () => {
							if (UploadsManager.uploads_in_progress) {
								return
							}

							onClose()
						},
					}),
				m(IconButton, {
					class: s.btn_chevron,
					icon: IconChevronDown,
					'aria-label': `${vnode.state.is_collapsed ? 'Expand' : 'Collapse'} uploads container`,
					onClick: () => {
						vnode.state.is_collapsed = !is_collapsed
					},
				}),
			]),
		]),
		m(
			'div',
			{ class: clsx(s.items_container, 'styled_scrollbar') },
			upload_items.map((upload_item) => m(UploadsRowItem, { upload_item, onCancelUpload })),
		),
	])
}

export default UploadsContainer
